// Drawing App - Brush Preset Storage
// localStorage-based user preset CRUD

import { SavedBrushPreset, BrushSettings, BrushPresetType, CustomBrushData } from './types';

const STORAGE_KEY = 'drawing-app-user-presets';

export class PresetStorage {
  private presets: SavedBrushPreset[] = [];

  constructor() {
    this.load();
  }

  getAll(): SavedBrushPreset[] {
    return [...this.presets];
  }

  save(
    name: string,
    settings: BrushSettings,
    color: string,
    presetType: BrushPresetType,
    customBrushData: CustomBrushData | null
  ): SavedBrushPreset {
    const preset: SavedBrushPreset = {
      id: this.generateId(),
      name,
      settings: { ...settings },
      color,
      presetType,
      customBrushData: customBrushData ? { ...customBrushData } : null,
      createdAt: Date.now(),
    };

    this.presets.push(preset);
    this.persist();
    return preset;
  }

  rename(id: string, newName: string): boolean {
    const preset = this.presets.find(p => p.id === id);
    if (!preset) return false;
    preset.name = newName;
    this.persist();
    return true;
  }

  delete(id: string): boolean {
    const idx = this.presets.findIndex(p => p.id === id);
    if (idx === -1) return false;
    this.presets.splice(idx, 1);
    this.persist();
    return true;
  }

  getById(id: string): SavedBrushPreset | null {
    return this.presets.find(p => p.id === id) || null;
  }

  private load(): void {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        this.presets = JSON.parse(raw);
      }
    } catch {
      this.presets = [];
    }
  }

  private persist(): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.presets));
    } catch (e) {
      console.error('[PresetStorage] Failed to save:', e);
    }
  }

  private generateId(): string {
    return `preset_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;
  }
}
